module.exports = __webpack_public_path__ + "static/media/discogs.72f990e7.png";